import React, { useState, useEffect } from 'react';
import '../../../urunDiv.css';
import '../sicak-kahveler/KahveDetay.css';
import FesleganliAyranResim from '../../../../assets/menu/icecekler/soguk-icecekler/fesleganli-ayran.jpeg';

const FeslegenliAyran = () => {
	const [isPhone, setIsPhone] = useState(window.innerWidth < 768);

	useEffect(() => {
		const handleResize = () => {
			setIsPhone(window.innerWidth < 768);
		};

		window.addEventListener("resize", handleResize);

		return () => {
			window.removeEventListener("resize", handleResize);
		};
	}, []);

	// Fesleğenli Ayran bilgileri
	const icecek = {
		name: 'Fesleğenli Ayran',
		price: '₺139,90',
		image: FesleganliAyranResim
	};

	const aciklama = 'Geleneksel ayran ile taze fesleğen yapraklarının mükemmel uyumu.';

	return (
		isPhone ? (
			<div className="americano-detay-container">
				{/* Product Section */}
				<div className="product-section">
					<div className="product-image-container">
						<img src={icecek.image} alt={icecek.name} className="product-image" />
						<div className="product-overlay">
							<div className="product-name-price">{icecek.name} - {icecek.price}</div>
						</div>
					</div>

					<div className="product-description">
						<p>{aciklama}</p>
					</div>
				</div>
			</div>
		) : (
			<div className="urun-detay-container-computer">
				{/* Product Section */}
				<div className="product-section">
					<div className="product-image-container">
						<img src={icecek.image} alt={icecek.name} className="product-image" />
						<div className="product-overlay">
							<div className="product-name-price">{icecek.name} - {icecek.price}</div>
						</div>
					</div>

					<div className="product-description-computer">
						<p>{aciklama}</p>
					</div>
				</div>
			</div>
		)
	);
};

export default FeslegenliAyran;
